import { useEffect } from "react";
import { fitTitle, fitDesc } from "@/lib/seoText";
// SEO head manager using React 19 native metadata hoisting.
// Emits page-variant tags + per-page JSON-LD. Global tags (og:image, twitter:card/image, og:site_name) live in
// index.html; per-page images overwrite those tags in place so crawlers never see duplicates.
const setGlobal = (selector, value) => {
  const tag = document.querySelector(selector);
  if (!value || !tag) return () => {};
  const prev = tag.getAttribute("content");
  tag.setAttribute("content", value);
  return () => tag.setAttribute("content", prev);
};

export default function Seo({ title, description, canonical, jsonLd, type = "website", image, noindex = false }) {
  useEffect(() => {
    const undo = [setGlobal('head meta[property="og:image"]', image), setGlobal('head meta[name="twitter:image"]', image)];
    return () => undo.forEach((u) => u());
  }, [image]);
  useEffect(() => setGlobal('head meta[name="robots"]', noindex ? "noindex, follow" : null), [noindex]);
  const t = fitTitle(title);
  const d = fitDesc(description);
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <>
      {t && <title>{t}</title>}
      {d && <meta name="description" content={d} />}
      {canonical && <link rel="canonical" href={canonical} />}

      {t && <meta property="og:title" content={t} />}
      {d && <meta property="og:description" content={d} />}
      <meta property="og:type" content={type} />
      {canonical && <meta property="og:url" content={canonical} />}
      {t && <meta name="twitter:title" content={t} />}
      {d && <meta name="twitter:description" content={d} />}

      {blocks.map((b, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }}
        />
      ))}
    </>
  );
}
